import React from 'react'
import { connect } from 'react-redux'

import ImageEditModal from '../image-edit/ImageEditModal'
import { addLinkImage } from '../../../actions/portal'

class LinkListImageEditModal extends React.Component {
  handleUpload = async ({ ref, currentImageId, onClose }) => {
    if (currentImageId) {
      this.props.onReloadImage()
    } else {
      await this.props.addLinkImage(ref, this.props.linkIndex)
    }
    onClose()
  }

  render() {
    return <ImageEditModal {...this.props} handleUpload={this.handleUpload} />
  }
}

export default connect(null, { addLinkImage })(LinkListImageEditModal)



// WEBPACK FOOTER //
// ./src/components/templates/link-list/LinkListImageEditModal.js